import React from "react";
import { WidgetProps } from "@rjsf/utils";
import { CustomCheckbox } from "../../../../../../Submissions/Widgets";
import BaseWidgetPreview from "./BaseWidgetPreview";

const CheckboxWidgetPreview = (props: WidgetProps) => {
  const widgetPreview = <CustomCheckbox {...props} />;
  return (
    <BaseWidgetPreview
      widgetPreview={widgetPreview}
      {...props}
    ></BaseWidgetPreview>
  );
};

export default CheckboxWidgetPreview;
